import { mountVueComponent } from '@/lib/mount-vue-component';

export default function () {
	import('@/modules/entries/components/Eligibility.vue').then((eligibility) => {
		mountVueComponent('eligibility', eligibility);
	});
}
